import React, { useEffect, useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";
import { useMediaQuery } from "react-responsive";
import SEOMeta from "components/app/SEOMeta";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

function Telecollaboration() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  //dispatch
  const dispatch = useDispatch();
  const [body, setBody] = useState(1);
  const [info, setInfo] = useState(1);

  const infoBodyList = [
    {
      img: `img/smartspace/consolution2${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <div>
          스마트 텔레헬스 협진 시스템은 화상회의 플랫폼을 통해 고해상도 화상
          협진을 지원합니다.
          <br />
          이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
          도와줍니다.
          <br />
          최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심 협진이
          가능하며, 참여자들은 간편하게 회의에 참여할 수 있습니다.
        </div>
      ),
    },
    {
      img: `img/smartspace/collaboration2${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <div>
          Zoom Chat을 통해 데스크탑과 모바일에서 상시 소통이 가능합니다.
          지속적인 상호작용을 지원하여, 파일과 영상의 원활한 열람 및 공유가
          이루어집니다. 내부 및 외부 네트워크 통합 연락처를 지원하며, 폴더,
          별표, 맨션, 북마크 등 다양한 기능을 통해 편리하게 사용할 수 있습니다.
          보안 채널 구성을 통해 데이터의 보안성을 강화합니다.
        </div>
      ),
    },
    {
      img: `img/smartspace/collaboration3${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <div>
          Zoom Phone을 활용한 긴급 커뮤니케이션 기능은 응급 상황에서 신속하고
          효과적인 의사소통을 지원합니다. 이는 응급실이나 긴급 진료 상황에서
          다자간 고품질 음성 통화를 통해 빠르게 대응할 수 있도록 돕습니다. 다중
          플랫폼 접근성을 통해 다양한 기기에서 쉽게 사용할 수 있으며, 환자
          치료에 있어 신속하고 효과적인 대응을 가능하게 합니다.
        </div>
      ),
    },
    {
      img: `img/smartspace/collaboration4${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt: (
        <div>
          리브테크놀로지의 협진 시스템은 Zoom의 다양한 기능을 내재화한 자체 협진
          플랫폼을 구축하여, 모든 협진 활동을 하나의 플랫폼에서 관리할 수
          있습니다.
          <br />이 플랫폼은 비대면 진료, 협진, 교육 및 학술대회 등 다양한 용도로
          활용될 수 있으며, 의료진 간의 협력을 극대화하고 진료의 연속성을
          보장합니다.
          <br />
          이를 통해 의료진은 효율적으로 소통하고 협력하여 환자에게 최상의 진료를
          제공할 수 있습니다.
        </div>
      ),
    },
  ];
  const infoList = [
    {
      header: "글로벌 협업 및 접근성 향상",
      img: `img/smartspace/collaborationInfo1${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt:
        !isMobile && !isTablet ? (
          <>
            스마트 텔레헬스 협진 시스템은 Zoom Video를 통해 고해상도 화상 협진을
            지원합니다.
            <br />
            <br />
            이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
            도와줍니다. 최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심
            협진이 가능하며, 참여자들은 간편하게 회의에 참여할 수 있습니다.
            대기실 기능을 통해 강화된 접근 보안을 제공하며, 모든 참가자의 발언과
            의견을 명확하게 전달합니다.
          </>
        ) : (
          <>
            스마트 텔레헬스 협진 시스템은 Zoom Video를 통해 고해상도 화상 협진을
            지원합니다.
            <br />
            <br />
            이는 장소와 시간에 구애받지 않고 의료진이 원활하게 협력할 수 있도록
            도와줍니다. 최고 수준의 음질과 화질을 보장하여 끊김 없는 영상 중심
            협진이 가능하며, 참여자들은 간편하게 회의에 참여할 수 있습니다.
            대기실 기능을 통해 강화된 접근 보안을 제공하며, 모든 참가자의 발언과
            의견을 명확하게 전달합니다.
          </>
        ),
    },
    {
      header: "팀 기반 협진 시스템 전략",
      img: `img/smartspace/collaborationInfo2${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt:
        !isMobile && !isTablet ? (
          <>
            인공지능 화상회의 장비 neat는 고해상도 비디오와 명확한 사운드를
            제공하여 팀 기반 협진을 지원합니다. 사용하기 쉬운 인터페이스를 통해
            복잡한 기술 없이도 손쉽게 시스템을 활용할 수 있습니다. 또한 문서
            공유, 화이트보드 실시간 편집 도구 등을 제공하여 효과적인 아이디어
            공유와 심화 논의를 지원합니다. 이는 협진의 질을 높이고 최적의 치료
            계획을 수립하는데 기여합니다.
          </>
        ) : (
          <>
            인공지능 화상회의 장비 neat는 고해상도 비디오와 명확한 사운드를
            제공하여 팀 기반 협진을 지원합니다. 사용하기 쉬운 인터페이스를 통해
            복잡한 기술 없이도 손쉽게 시스템을 활용할 수 있습니다. 또한 문서
            공유, 화이트보드 실시간 편집 도구 등을 제공하여 효과적인 아이디어
            공유와 심화 논의를 지원합니다. 이는 협진의 질을 높이고 최적의 치료
            계획을 수립하는데 기여합니다.
          </>
        ),
    },
    {
      header: "개인 간 협진 시스템 전략",
      img: `img/smartspace/collaborationInfo3${!isMobile && !isTablet ? "" : "_m"}.png`,
      txt:
        !isMobile && !isTablet ? (
          <>
            neat.frame 화상장비를 통해 의료진은 개별적으로 협진을 진행할 수
            있습니다.
            <br />
            개인형 디바이스로 다양한 의료 전문가들과 자식을 나누고 서로를
            지원하며 의료진의 전문적 성장을 지원하고 혁신적인 접근 방식을
            도입하는데 기여합니다.
          </>
        ) : (
          <>
            neat.frame 화상장비를 통해 의료진은 개별적으로 협진을 진행할 수
            있습니다.
            <br />
            개인형 디바이스로 다양한 의료 전문가들과 자식을 나누고 서로를
            지원하며 의료진의 전문적 성장을 지원하고 혁신적인 접근 방식을
            도입하는데 기여합니다.
          </>
        ),
    },
  ];

  // const [infoBody, setInfoBody] = useState({});
  // useEffect(() => {
  //   setInfoBody(infoBodyList[info - 1]);
  // }, [info]);

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    {
      id: 1,
      img: `img/device/neat/swiper_board_pro${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "협진 화상회의 장비 neat.board pro",
      txt: "Neat Board Pro는 협진 환경에 최적화된 65인치 올인원 협업 디스플레이로, 고해상도 듀얼 카메라 시스템과 우수한 오디오 성능을 통해 의료진 간의 원활한 원격 협진을 지원합니다. 직관적인 터치스크린 인터페이스로 사용 편의성을 높였습니다.",
      onClick: () => showDrawer("boardpro"),
    },
    {
      id: 2,
      img: `img/device/neat/swiper_frame${!isMobile && !isTablet ? "" : "_m"}.png`,
      title: "neat. frame",
      txt: "Neat Frame은 개인 협진 및 원격 진료에 최적화된 올인원 화상회의 디바이스로, 병원 진료실, 개별연구실, 원격 근무 환경에서 의료진 간 원활한 협업을 지원합니다. 공간을 최소화하면서도 최적의 협진 환경을 제공하는 스마트 디바이스 입니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      }),
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <SEOMeta
        title="원격 협진 시스템, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - 원격 협진 시스템"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 텔레헬스, 비대면 진료, 
        스마트 텔레헬스 시스템, 원격 협진"
      />
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Tele-Collaboration System</p>
          <p>원격 협진 시스템</p>
          {!isMobile && !isTablet ? (
            <p>
              리브테크놀로지의 협진 플랫폼은 All in One 솔루션으로, 통합된
              기능과 확장성을 제공합니다. <br />이 플랫폼은 원격 진료 · 협진 ·
              의료 세미나 등의 다양한 기능을 하나의 시스템에 통합하여, 의료진과
              환자가 하나의 플랫폼에서 모든 진료 활동을 효율적으로 관리할 수
              있게 합니다. <br />
              이를 통해 의료 서비스의 품질을 높이고, 진료의 연속성과 효율성을
              극대화할 수 있습니다.
            </p>
          ) : (
            <p>
              리브테크놀로지의 협진 플랫폼은
              <br />
              All in One 솔루션으로,
              <br />
              통합된 기능과 확장성을 제공합니다.
              <br />
              이 플랫폼은 원격 진료 · 협진 · 의료 세미나 등의
              <br />
              다양한 기능을 하나의 시스템에 통합하여,
              <br />
              의료진과 환자가 하나의 플랫폼에서
              <br />
              모든 진료 활동을 효율적으로 관리할 수 있게 합니다.
              <br />
              이를 통해 의료 서비스의 품질을 높이고,
              <br />
              진료의 연속성과 효율성을 극대화할 수 있습니다.
            </p>
          )}
        </div>
        <div className={style.healthImg}>
          <img
            alt=""
            src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/collaborationImg1${!isMobile && !isTablet ? "" : "_m"}.png`}
          />
        </div>

        <div className={style.consolutionBody}>
          <div className={style.consolutionWrap}>
            {!isMobile && !isTablet ? (
              <div className={style.consolutionBodyTitle}>
                <p>
                  리브테크놀로지의 <font> 스마트 텔레헬스 협진 시스템</font>은
                  다양한 기능들을 통합하여,
                </p>
                <p>
                  의료진에게 <font>최적의 협진 환경을 제공</font>합니다.
                </p>
                <p>
                  구성 환경은 공간과 목적에 따라 맞추형으로 조정 및 변경이
                  가능합니다.
                </p>
              </div>
            ) : (
              <div className={style.consolutionBodyTitle}>
                <p>
                  리브테크놀로지의 <bold>스마트 텔레헬스 협진</bold>
                  <br />
                  <bold>시스템</bold>은 다양한 기능들을 통합하여,
                  <br />
                  의료진에게 <bold>최적의 협진 환경을 제공</bold>합니다.
                </p>
                <p>
                  구성 환경은 공간과 목적에 따라 맞추형으로 조정 및 변경이
                  가능합니다.
                </p>
              </div>
            )}
            <div className={style.consolutionBodyInfo}>
              <div className={style.consolutionBodyInfoWrap1}>
                <div>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/zoomLogo${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                  {(isMobile || isTablet) && (
                    <div>
                      0{body} / <font>0{infoBodyList.length}</font>
                    </div>
                  )}
                </div>
                <div className={style.consolutionInfoBtnList}>
                  <div
                    className={body === 1 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(1)}
                  >
                    <p>
                      {!isMobile && !isTablet && <font>01</font>}
                      <font>화상 협진</font>
                    </p>
                    <p>Video</p>
                  </div>
                  <div
                    className={body === 2 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(2)}
                  >
                    <p>
                      {!isMobile && !isTablet && <font>02</font>}
                      <font>상시 소통</font>
                    </p>
                    <p>Chat</p>
                  </div>
                  <div
                    className={body === 3 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(3)}
                  >
                    <p>
                      {!isMobile && !isTablet && <font>03</font>}
                      <font>응급 소통</font>
                    </p>
                    <p>Phone</p>
                  </div>
                  <div
                    className={body === 4 ? style.bodyOn : style.bodyOff}
                    onClick={() => setBody(4)}
                  >
                    <p>
                      {!isMobile && !isTablet && <font>04</font>}
                      <font>
                        맞춤형{!isMobile && !isTablet ? "" : <br />}협진 플랫폼
                        구축
                      </font>
                    </p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div className={style.consolutionBodyInfoWrap2}>
                {!isMobile && !isTablet && (
                  <div>
                    <font>0{body} / </font>
                    <font>04</font>
                  </div>
                )}
                <div>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}${infoBodyList[body - 1].img}`}
                  />
                </div>
                {/* <div>{infoBodyList[body - 1].txt}</div> */}
                {infoBodyList[body - 1].txt}
              </div>
            </div>
          </div>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/teleBackgroundImg${!isMobile && !isTablet ? "" : "_m"}.png')`,
          }}
        >
          <div className={style.consolutionInfo}>
            {!isMobile && !isTablet ? (
              <div className={style.consolutionInfoHeader}>
                <font>리브테크놀로지의 Telehealth</font>
                <font>원격협진 시스템</font>
              </div>
            ) : (
              <div className={style.consolutionInfoHeader}>
                리브테크놀로지의 Telehealth
                <br />
                <bold>원격협진 시스템</bold>
              </div>
            )}
            <div className={style.consolutionInfoTypeList}>
              <div
                onClick={() => {
                  setInfo(1);
                }}
                className={info === 1 ? style.infoOn : style.infoOff}
              >
                {" "}
                글로벌 협업 및 <br /> 접근성 향상
              </div>
              <div
                className={info === 2 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(2);
                }}
              >
                팀 기반 <br /> 협진 시스템 전략
              </div>
              <div
                className={info === 3 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(3);
                }}
              >
                개인 간<br /> 협진 시스템 전략
              </div>
            </div>
            <div className={style.consolutionInfoBody}>
              <div>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}${infoList[info - 1].img}`}
                />
              </div>
              <div>
                <font>{infoList[info - 1].header}</font>
                <font>{infoList[info - 1].txt}</font>
                {/* {infoList[info - 1].body2} */}
              </div>
            </div>
          </div>
        </div>
        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}

            <Swiper
              scrollbar={{ draggable: true }}
              slidesPerView={"auto"}
              spaceBetween={"4%"}
              modules={[Scrollbar]}
              className={style.commonComposeCardWrap}
              observer={true}
              observeParents={true}
              observeSlideChildren={true}
              grabCursor={true}
            >
              {Compose.map((info, index) => (
                <SwiperSlide className={style.commonComposeCard} key={index}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    >
                      <div>
                        <font>More</font>{" "}
                        <img
                          alt=""
                          src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/arrowRight${!isMobile && !isTablet ? "" : "_m"}.png`}
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div> */}
            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/smartspace/composefooterImg${!isMobile && !isTablet ? "" : "_m"}.png')`,
                }}
              >
                <p>
                  <img
                    className={style.bang}
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}img/smartspace/bang${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </p>
                {!isMobile && !isTablet ? (
                  <p>
                    <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다.
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                ) : (
                  <p>
                    <bold>기업 환경에 맞춰</bold> 선택하여 구축 가능합니다.
                    <br />
                    상담을 통해 정확히 진단해 보세요.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default Telecollaboration;
